import { createContext } from 'react';

import { SelectedGlcContextProps } from './SelectedGlcContext.types';

export const SelectedGlcContext = createContext<SelectedGlcContextProps | undefined>(undefined);
